export default "__VITE_ASSET__B6iAeD8l__"